// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__FedraSansStdBook_eafba3', '__FedraSansStdBook_Fallback_eafba3'","fontStyle":"normal"},"className":"__className_eafba3","variable":"__variable_eafba3"};